import React, { useEffect, useState } from "react";
import {
  CssBaseline,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,useTheme,

  
} from "@mui/material";
import { Close, Add, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

import { callApi } from "../../../utils/apiClient";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";

import RepulpAddUpdateWT from "./RepulpAddUpdateWT";
import CallAlertBar from "../../../Layout/Alertbar";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import { tokens } from "../../../theme/theme";

const RepulpWasteTypeIndex = ({ handleBackWinderMachineEntry }) => {
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedWT, setSelectedWT] = useState({});

  const [filters, setFilters] = useState({
    waste_type_name: "",
    status: "",
  });

  // Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuText, setMenuText] = useState("All Waste Types");

  // Alerts
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // ===========================
  // Menu Handlers
  // ===========================
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleMenuItemClick = (option) => {
    setMenuText(option);
    handleMenuClose();

    if (option === "All Waste Types") setFilteredList(list);
    else if (option === "Active Waste Types")
      setFilteredList(list.filter((x) => x.status === true || x.status === "Active"));
    else if (option === "Inactive Waste Types")
      setFilteredList(list.filter((x) => x.status === false || x.status === "Inactive"));
  };

  // ===========================
  // Load Waste Types
  // ===========================
  const loadWasteTypeList = () => {
    const payload = {
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
    };

    callApi(
      Production_API_ENDPOINTS.repulpmaster?.wastetypelist ||
        "/api/repulpmaster/wastetypelist",
      "POST",
      { "Content-Type": "application/json" },
      payload
    )
      .then((res) => {
        setList(res || []);
        setFilteredList(res || []);
      })
      .catch(() => {
        setList([]);
        setFilteredList([]);
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Failed to load waste type list.");
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    loadWasteTypeList();
  }, []);

  // ===========================
  // Column Filters
  // ===========================
  useEffect(() => {
    const filtered = list.filter((row) => {
      const statusText =
        row.status === true || row.status === "Active" ? "active" : "inactive";

      return (
        (row.waste_type_name || "")
          .toLowerCase()
          .includes(filters.waste_type_name.toLowerCase()) &&
        statusText.includes(filters.status.toLowerCase())
      );
    });

    setFilteredList(filtered);
  }, [filters, list]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  // ===========================
  // Form Handlers
  // ===========================
  const handleAdd = () => {
    setSelectedWT({});
    setIsFormOpen(true);
  };

  const handleEdit = (row) => {
  setSelectedWT(row);   // full row passed
  setIsFormOpen(true);
};

  const handleExit = () => {
    handleBackWinderMachineEntry();
  };

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />

          {/* ===== Top Bar ===== */}
          <AppBar
            position="static"
            sx={{
              backgroundColor: "inherit",
              borderRadius: "0px",
              height: "48px",
              justifyContent: "center",
            }}
          >
            <Toolbar>
              {/* Menu Filter */}
              <Box>
                <Button
                  color="secondary"
                  onClick={handleMenuClick}
                  endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: 18 }} />}
                  sx={{ textTransform: "none", fontSize: 16, fontWeight: 500 }}
                >
                  {menuText}
                </Button>

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                  <MenuItem onClick={() => handleMenuItemClick("All Waste Types")}>
                    All Waste Types
                  </MenuItem>
                  <MenuItem onClick={() => handleMenuItemClick("Active Waste Types")}>
                    Active Waste Types
                  </MenuItem>
                  <MenuItem onClick={() => handleMenuItemClick("Inactive Waste Types")}>
                    Inactive Waste Types
                  </MenuItem>
                </Menu>
              </Box>

              <Button
                variant="contained"
                color="secondary"
                startIcon={<Add />}
                sx={{ ml: "auto" }}
                onClick={handleAdd}
              >
                New Waste Type
              </Button>

              <IconButton onClick={handleExit}>
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>

          {/* Alerts */}
          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          {/* ===== Table ===== */}
          <Box p={1}>
            <CustomTableContainer colors={colors}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Waste Type</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Search Waste Type"
                        value={filters.waste_type_name}
                        onChange={(e) =>
                          handleFilterChange("waste_type_name", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Search Status"
                        value={filters.status}
                        onChange={(e) =>
                          handleFilterChange("status", e.target.value)
                        }
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredList.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell
                        sx={{ color: "teal", cursor: "pointer" }}
                        onClick={() => handleEdit(row)}
                      >
                        {row.id}
                      </TableCell>
                      <TableCell>
                        {row.name}
                      </TableCell>
                      <TableCell>
                        {row.status === true ? "Active" : "Inactive"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            </CustomTableContainer>
          </Box>
        </>
      )}

      {isFormOpen && (
       <RepulpAddUpdateWT
  selectedWT={selectedWT}
  onClose={() => setIsFormOpen(false)}
  loadWasteTypeList={loadWasteTypeList}
/>
      )}
    </Grid>
  );
};

export default RepulpWasteTypeIndex;
